import { growthBookFeatureFlags } from '@utils/featureFlags';
import { growthBook } from '@utils/growthBook';
// Gates GET_STEP_DRIVE_OCCURRENCES and is the only CX_SELF_SCHEDULE_ENABLED read for self-booking:
// routing keys off whether drive_occurrences came back. Only self-book invites (wcs_id) ask for it.
export const shouldIncludeDriveOccurrences = (wcsId) => Boolean(wcsId) && Boolean(growthBook?.getFeatureValue(growthBookFeatureFlags.CX_SELF_SCHEDULE_ENABLED, false));
